export default {
  connected: false,
  socket: null,
  callbackId: 0,
  callbacks: {},

  init: function (onInit, onStorageUpdate) {
    this.socket = io.connect();
    this.socket.on('init', onInit);
    this.socket.on('disconnect', this.onDisconnect.bind(this));
    this.socket.on('connect', this.onConnect.bind(this));
    this.socket.on('logout', this.onDisconnect.bind(this));
    this.socket.on('UserStorageSet', onStorageUpdate)
  },

  logout: function () {
    this.connected = false;
    this.socket.emit('logout');
  },

  onConnect: function () {
    //console.log('onConnect', arguments);
    this.connected = true;
  },

  onDisconnect: function () {
    //console.log('onDisconnect', arguments);
    this.connected = false;
    location.href = '/auth/';
  },

  call: function () {
    if (typeof arguments[arguments.length - 1] === 'function') {
      let callback = arguments[arguments.length - 1];
      arguments[arguments.length - 1] = function (response) {
        if (response.Error && response.Error.Key === 'AccessDenied') {
          alert(response.Error.Message);
        } else {
          callback(response);
        }
      }
    }
    this.socket.emit.apply(this.socket, arguments);
  },

  emit: function () {
    let args = Array.prototype.slice.call(arguments, 0);
    this.call.apply(this, ['call'].concat(args));
  },

  /**
   * Создание нового пользователя
   * @param props
   * @param callback
   */
  userRecordNew: function (props, callback) {
    this.call('UserRecordNew', props, callback);
  },

  userRecordDelete: function (login, callback) {
    this.call('UserRecordDelete', login, callback);
  },

  userAddBalance: function (data, callback) {
    this.call('UserAddBalance', data, callback);
  },

  userAddCredit: function (data, callback) {
    this.emit('UserAddCredit', data, callback);
  },

  userGetBalance: function (data, callback) {
    this.call('UserGetBalance', data, callback);
  },

  userSearch: function (query, callback) {
    this.call('SearchUsers', query, callback);
  },

  userRecordGet: function (login, callback) {
    this.call('UserRecordGet', login, callback);
  },

  userGetOpenedOrders: function (query, callback) {
    this.call('UserGetOpenedOrders', query, callback);
  },

  userGetClosedOrders: function (query, callback) {
    this.call('UserGetClosedOrders', query, callback);
  },

  tagsGet: function (context, callback) {
    this.call('TagsGet', context, callback);
  },

  tagAdd: function (context, name, callback) {
    this.call('TagAdd', context, name, callback);
  },

  tagUpdate: function (context, oldName, newName, callback) {
    this.call('TagUpdate', context, oldName, newName, callback);
  },

  tagRemove: function (context, name, callback) {
    this.call('TagRemove', context, name, callback);
  },

  tagAddTo: function (context, where, name, callback) {
    this.call('TagAddTo', context, where, name, callback);
  },
  tagRemoveFrom: function (context, where, name, callback) {
    this.call('TagRemoveFrom', context, where, name, callback);
  },
  checkBalance: function (where, callback) {
    this.call('CheckBalance', where, callback);
  },

  fixBalance: function (where, callback) {
    this.call('FixBalance', where, callback);
  },

  currenciesGet: function (callback) {
    this.call('CurrenciesGet', callback);
  },

  currencyAdd: function (data, callback) {
    this.call('CurrencyAdd', data, callback);
  },

  /**
   * Отредактировать валюту
   * @param data
   * @param callback
   */
  currencyUpdate: function (data, callback) {
    this.call('CurrencyUpdate', data, callback);
  },

  /**
   * Удалить валюту
   * @param name
   * @param callback
   */
  currencyRemove: function (name, callback) {
    this.call('CurrencyRemove', name, callback);
  },

  /**
   * Список символов
   * @param callback
   */
  symbolsGet: function (callback) {
    this.call('SymbolsGet', callback);
  },

  /**
   * Добавить Символ
   * @param data
   * @param callback
   */
  symbolAdd: function (data, callback) {
    this.call('SymbolAdd', data, callback);
  },

  /**
   * Отредактировать символ
   * @param data
   * @param callback
   */
  symbolUpdate: function (data, callback) {
    this.call('SymbolUpdate', data, callback);
  },

  /**
   * Удалить символ
   * @param name
   * @param callback
   */
  symbolRemove: function (name, callback) {
    this.call('SymbolRemove', name, callback);
  },

  /**
   * Символьные Сессии
   * @param id
   * @param callback
   */
  symbolSessionsGet: function (id, callback) {
    this.call('SymbolSessionsGet', id, callback);
  },

  /**
   * Записать символьные сессии
   * @param id
   * @param sessions
   * @param callback
   */
  symbolSessionsSet: function (id, sessions, callback) {
    this.call('SymbolSessionsSet', id, sessions, callback);
  },

  /**
   * Получить настройки пользователя
   * @param where
   * @param callback
   */
  userSettingsGet: function (where, callback) {
    this.call('UserSettingsGet', where, callback);
  },

   /**
   * 
   * @param callback
   */

  customGroupUserMapGet: function (data, callback) {
    this.call('CustomGroupUserMapGet', data, callback);
  },

  /**
   * Изменить настройки пользователя
   * @param where
   * @param data
   * @param callback
   */
  userSettingsSet: function (where, data, callback) {
    this.call('UserSettingsSet', where, data, callback);
  },

  /**
   * Список шаблонов пользователей
   * @param callback
   */
  userSettingsTemplatesGet: function (callback) {
    this.call('UserSettingsTemplatesGet', callback);
  },

  /**
   * Добавить шаблон пользователя
   * @param data
   * @param callback
   */
  userSettingsTemplateAdd: function (data, callback) {
    this.emit('UserSettingsTemplateAdd', data, callback);
  },

  /**
   * Обновить шаблон пользователя
   * @param data
   * @param callback
   */
  userSettingsTemplateUpdate: function (data, callback) {
    this.emit('UserSettingsTemplateUpdate', data, callback);
  },

  /**
   * Удалить шаблон пользователя
   * @param name
   * @param callback
   */
  userSettingsTemplateRemove: function (name, callback) {
    this.call('UserSettingsTemplateRemove', name, callback);
  },

  userSettingsTemplateCopy: function (name, callback) {
    this.call('UserSettingsTemplateCopy', name, callback);
  },

  
  /**
   * 
   * @param callback
   */
  defaultJsonValuesGet: function (symbols, callback) {    
    this.call('DefaultJsonValuesGet', symbols, callback);
  },

  /**
   * 
   * @param callback
   */
  custSymbolGroupsGet: function (callback) {
    this.call('CustSymbolGroupsGet', callback);
  },
  

  /**
   * Добавить шаблон пользователя
   * @param data
   * @param callback
   */
  custSymbolGroupsAdd: function (data, callback) {
    this.emit('CustSymbolGroupsAdd', data, callback);
  },
  

  /**
   * Обновить шаблон пользователя
   * @param data
   * @param callback
   */
  custSymbolGroupsUpdate: function (data, callback) {
    this.emit('CustSymbolGroupsUpdate', data, callback);
  },

  /**
   * Удалить шаблон пользователя
   * @param name
   * @param callback
   */
  custSymbolGroupsRemove: function (name, callback) {
    this.call('CustSymbolGroupsRemove', name, callback);
  },

  custSymbolGroupsCopy: function (name, callback) {
    this.call('CustSymbolGroupsCopy', name, callback);
  },

  getServerDetails: function (callback) {
    this.call('GetServerDetails', callback);
  },
  
  restartHistoryServer: function (data, callback) {
    this.call('RestartHistoryServer',data, callback);
  }, 

  samplersGet: function (callback) {
    this.call('SamplersGet', callback);
  },

  samplerGet: function (data, callback) {
    this.call('SamplerGet', data, callback);
  },

  searchOrders: function (query, callback) {
    this.emit('SearchOrders', query, callback);
  },
  searchLogs: function (query, callback) {
    this.call('SearchLogs', query, callback);
  },

  ordersClose: function (query, callback) {
    this.emit('OrdersClose', query, callback);
  },
  ordersDelete: function (query, callback) {
    this.emit('OrdersDelete', query, callback);
  },
  ordersUpdate: function (query, callback) {
    this.call('OrdersUpdate', query, callback);
  },
  orderOpen: function (query, callback) {
    this.call('OrderOpen', query, callback);
  },
  orderGet: function (ticket, callback) {
    this.call('OrderGet', ticket, callback);
  },
  commonSettingsGet: function (callback) {
    this.call('CommonSettingsGet', callback);
  },
  commonSettingsSet: function (settings, callback) {
    this.call('CommonSettingsSet', settings, callback);
  },
  symbolSessionsGlobalGet: function (callback) {
    this.call('SymbolSessionsGlobalGet', callback);
  },
  symbolSessionsGlobalSet: function (sessions, callback) {
    this.call('SymbolSessionsGlobalSet', sessions, callback);
  },
  reboot: function (callback) {
    this.call('Reboot', callback);
  },
  newsFeedAdd: function (query, callback) {
    this.call('NewsFeedAdd', query, callback);
  },
  newsFeedUpdate: function (query, callback) {
    this.call('NewsFeedUpdate', query, callback);
  },
  newsFeedRemove: function (id, callback) {
    this.call('NewsFeedRemove', id, callback);
  },
  newsFeedsGet: function (callback) {
    this.call('NewsFeedsGet', callback);
  },
  newsSend: function (query, callback) {
    this.call('NewsSend', query, callback);
  },
  managersGet: function (callback) {
    this.call('ManagersGet', callback);
  },
  managerRightsGet: function (condition, callback) {
    this.call('ManagerRightsGet', condition, callback);
  },
  managerRightsSet: function (query, callback) {
    this.call('ManagerRightsSet', query, callback);
  },
  managerModulesGet: function (callback) {
    this.call('ManagerModulesGet', callback);
  },
  mailSettingsGet: function (callback) {
    this.call('MailSettingsGet', callback);
  },
  mailSettingsUpdate: function (query, callback) {
    this.call('MailSettingsUpdate', query, callback);
  },
  mailSend: function (query, callback) {
    this.call('MailSend', query, callback);
  },
  appsGet: function (callback) {
    this.call('AppsGet', callback);
  },
  appAdd: function (query, callback) {
    this.call('AppAdd', query, callback);
  },
  appUpdate: function (query, callback) {
    this.call('AppUpdate', query, callback);
  },
  appRemove: function (id, callback) {
    this.call('AppRemove', id, callback);
  },

  quoteFeedsGet: function (callback) {
    this.emit('QuoteFeedsGet', callback);
  },

  quoteFeedAdd: function (query, callback) {
    this.emit('QuoteFeedAdd', query, callback);
  },

  quoteFeedUpdate: function (query, callback) {
    this.emit('QuoteFeedUpdate', query, callback);
  },

  quoteFeedRemove: function (id, callback) {
    this.emit('QuoteFeedRemove', {
      Id: id
    }, callback);
  },

  quoteFeedSymbolsGet: function (callback) {
    this.emit('QuoteFeedSymbolsGet', callback);
  },

  quoteFeedSymbolAdd: function (query, callback) {
    this.emit('QuoteFeedSymbolAdd', query, callback);
  },



  quoteFeedSymbolUpdate: function (query, callback) {
    this.emit('QuoteFeedSymbolUpdate', query, callback);
  },

  quoteFeedSymbolRemove: function (id, callback) {
    this.emit('QuoteFeedSymbolRemove', {
      Id: id
    }, callback);
  },

  quoteHistoryGet: function (callback) {
    this.emit('QuoteHistoryGet', callback);
  },

  quoteHistorySymbolsGet: function (callback) {
    this.emit('QuoteHistorySymbolsGet', callback);
  },

  historyRebuildStop: function (key, callback) {
    this.emit('QuoteHistorySymbolRebuildStop', {SymbolKey: key}, callback);
  },

  historyRebuildStart: function (key, callback) {
    this.emit('QuoteHistorySymbolRebuildStart', {SymbolKey: key}, callback);
  },

  historyGetRebuildStatus: function (key, callback) {
    this.emit('QuoteHistorySymbolGetRebuildStatus', {SymbolKey: key}, callback);
  },

  optionsTypeSettingsGet: function (callback) {
    this.emit('OptionsTypeSettingsGet', callback);
  },

  optionsTypeSettingsUpdate: function (item, callback) {
    this.emit('OptionsTypeSettingsUpdate', item, callback);
  },

  optionsPeriodSettingsGet: function (id, callback) {
    this.emit('OptionsPeriodSettingsGet', {TypeId: id}, callback);
  },

  optionsPeriodSettingsAdd: function (item, callback) {
    this.emit('OptionsPeriodSettingsAdd', item, callback);
  },

  optionsPeriodSettingsUpdate: function (item, callback) {
    this.emit('OptionsPeriodSettingsUpdate', item, callback);
  },

  optionsPeriodSettingsRemove: function (typeId, periodId, callback) {
    this.emit('OptionsPeriodSettingsRemove', {TypeId: typeId, PeriodId: periodId}, callback);
  },

  formTemplatesGet: function (type, callback) {
    this.emit('FormTemplatesGet', {Type: type}, callback);
  },

  formTemplatesAdd: function (item, callback) {
    this.emit('FormTemplatesAdd', item, callback);
  },

  formTemplatesRemove: function (id, callback) {
    this.emit('FormTemplatesRemove', {Id: id}, callback);
  },

  formTemplatesUpdate: function (item, callback) {
    this.emit('FormTemplatesUpdate', item, callback);
  },

  searchBinaryOptions: function (query, callback) {
    this.emit('SearchOptions', query, callback);
  },

  quoteHistoryTicksGet: function (query, callback) {
    this.emit('QuoteHistoryTicksGet', query, callback);
  },

  userCheckPassword: function (query, callback) {
    this.emit('UserCheckPassword', query, callback);
  },

  userStorageGet: function (login, callback) {
    this.emit('UserStorageGet', {Login: login}, callback);
  },

  userStorageSet: function (login, value, callback) {
    this.emit('UserStorageSet', {Login: login, Value: value}, callback);
  },

  quoteHistoryMissingHoursStats: function (symbolKeys, callback) {
    this.emit('QuoteHistoryMissingHoursStats', {SymbolKeys: symbolKeys}, callback);
  },

  quoteHistoryMissingHoursGet: function (symbolKey, callback) {
    this.emit('QuoteHistoryMissingHoursGet', {SymbolKey: symbolKey}, callback);
  },

  getVersions: function (callback) {
    this.emit('GetVersions', callback);
  },

  userRecordUpdate: function (query, callback) {
    this.emit('UserRecordUpdate', query, callback);
  },

  searchLogsSchemaGet: function (callback) {
    this.emit('SearchLogsSchemaGet', callback);
  },

  searchOrdersAndOptions: function (query, callback) {
    this.emit('SearchOrdersAndOptions', query, callback);
  },

  pluginsGet: function (callback) {
    this.emit('PluginsGet', callback);
  },

  pluginUpdateParams: function (query, callback) {
    this.emit('PluginUpdateParams', query, callback);
  },

  pluginEnable: function (query, callback) {
    this.emit('PluginEnable', query, callback);
  }

};



// WEBPACK FOOTER //
// ./src/js/Remote.js